/* eslint-disable react-refresh/only-export-components */
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { InsightsMappedCompaniesList } from '@/app/(client)/supply-chain-mapping/-components/insights/InsightsMappedCompaniesList';
import { useMappedCompaniesInsights } from '@/app/(client)/supply-chain-mapping/-hooks/useMappedCompaniesInsights';
import { PageContainer } from '@/components/shared/PageContainer';
import { useTable } from '@/hooks/useTable';

const insightsListSearch = z.object({
  page: z.number().int().min(1).catch(1),
  limit: z.number().int().min(10).max(500).catch(50),
  sort: z
    .string()
    .transform(v => (/^\w+:(ASC|DESC)$/.test(v) ? v : undefined))
    .optional(),
  filters: z
    .union([
      z.string().transform(v => {
        try {
          return JSON.parse(v) as Record<string, string[]>;
        } catch {
          return undefined;
        }
      }),
      z.record(z.array(z.string())),
    ])
    .optional(),
});

export const Route = createFileRoute(
  '/(client)/supply-chain-mapping/(pages)/(list)/insights/mapped-companies/',
)({
  validateSearch: insightsListSearch,
  component: InsightsMappedCompaniesPage,
});

function InsightsMappedCompaniesPage() {
  const table = useTable('scm-mapped-companies');

  const { data, isLoading } = useMappedCompaniesInsights({
    page: table.queryParams.page,
    count: table.queryParams.count,
    ...(table.queryParams.sort ? { sort: table.queryParams.sort } : {}),
    ...(table.queryParams.filter ? { filter: table.queryParams.filter } : {}),
  });

  const total = data?.meta?.totalCount ?? data?.meta?.total ?? 0;
  const pageCount = Math.ceil(total / table.limit) || 1;

  return (
    <PageContainer>
      <InsightsMappedCompaniesList
        data={data?.data ?? []}
        isLoading={isLoading}
        pagination={{ pageIndex: table.page - 1, pageSize: table.limit }}
        manualPageCount={pageCount}
        manualRowCount={total}
        onPaginationChange={table.onPaginationChange}
        sorting={table.sorting}
        onSortingChange={table.onSortingChange}
        filters={table.filters}
        onFiltersChange={table.onFiltersChange}
      />
    </PageContainer>
  );
}
